import React, { useState } from 'react'
import {
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import { NewTable } from "../customers/EditCustomerPage";

export default function FeatureTable({ data, featureData, setFeatureData }) {

    const [tableKey, setTableKey] = useState(0);


    function buttonFormatter(cell) {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={featureData.includes(cell._id)}
                            onChange={() => {
                                const updatedFeatures = featureData.includes(cell._id)
                                    ? featureData.filter(id => id !== cell._id)
                                    : [...featureData, cell._id];

                                setFeatureData([...updatedFeatures]);
                                setTableKey(k => k + 1);
                            }}
                            name="checkActive"
                        />
                    }
                />
            </>
        );
    }

    const columns = [
        { dataField: "title", text: "Title" },
        { dataField: "_id", text: "", formatter: (_, row) => buttonFormatter(row) },
    ];


    return (
        <>
            <div className="flex-grow-1">
                <NewTable key={tableKey} data={data} columns={columns} />
            </div>
        </>
    );
}